import { render, staticRenderFns } from "./PagePortfolio.vue?vue&type=template&id=785531b0&scoped=true&"
import script from "./PagePortfolio.vue?vue&type=script&lang=js&"
export * from "./PagePortfolio.vue?vue&type=script&lang=js&"
import style0 from "./PagePortfolio.vue?vue&type=style&index=0&id=785531b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785531b0",
  null
  
)

export default component.exports